module.exports = __webpack_public_path__ + "static/media/joe-root.31e98c76.jpg";